<template lang="pug">
router-link(tag="li", :to="href", active-class="active", exact)
  a(:href='href')
    p {{title}}
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    href: String
  }
}
</script>



// WEBPACK FOOTER //
// item.vue?ed808212